/**
 * How much of the viewport's bottom the on-screen keyboard is currently
 * covering, so the MAHI chat panel can lift itself clear of it instead of
 * being obscured. Best-effort via the VisualViewport API — this has not
 * been checked on a real device yet, only reasoned through; the spec is
 * explicit that a resized desktop browser window is not a substitute for
 * that check.
 */
import { useEffect, useState } from 'react';

export default function useVisualViewportInset() {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!vv) return undefined;
    const update = () => {
      const occluded = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setInset(occluded);
    };
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
